module.exports = __webpack_public_path__ + "media/logos/law360-logo-white-small-39d7a5dd.png";